import mapKeys from 'lodash/mapKeys';
import { parseFieldName } from '@sparknz/journeys-common';

import { BroadbandTrackingAttributes } from 'shared/types/cart';
import {
  SETUP_BACKUP_DEVICE_FIELD_NAME,
  SETUP_CALLER_DISPLAY_FIELD_NAME,
  SETUP_VULNERABLE_FIELD_NAME,
} from '../constants';
import { FormData } from '../types';

function hasAttribute(formData: FormData, key: string) {
  const value = formData[key];

  return typeof value === 'string' ? value.toLowerCase().includes('yes') : null;
}

export function getBroadbandAttributes(
  formData: FormData,
): BroadbandTrackingAttributes {
  const parsedFormData = mapKeys(formData, (_, key: string) =>
    parseFieldName(key),
  );

  const isVulnerable = hasAttribute(
    parsedFormData,
    SETUP_VULNERABLE_FIELD_NAME,
  );
  const isBackupDevice = hasAttribute(
    parsedFormData,
    SETUP_BACKUP_DEVICE_FIELD_NAME,
  );
  const isCallerDisplay = hasAttribute(
    parsedFormData,
    SETUP_CALLER_DISPLAY_FIELD_NAME,
  );

  return {
    isVulnerable,
    isBackupDevice,
    isCallerDisplay,
  };
}
